/** Wave 69 is the Zuk wave. See InfernoRegion.initialiseRegion(). */
export const ZUK_WAVE = 69;

/** TzKal-Zuk's max hitpoints, from his stats block in mobs/TzKalZuk.ts. */
export const ZUK_MAX_HP = 1200;

/** Each correct answer takes 10% of his health, so ten correct answers kill him. */
export const DAMAGE_PER_CORRECT = ZUK_MAX_HP / 10;

export const CORRECT_TO_KILL = ZUK_MAX_HP / DAMAGE_PER_CORRECT;

/**
 * With this many correct answers still to go, Zuk enrages — his attack speed drops from 10
 * ticks to 7, so the last stretch gives you noticeably less time between shots.
 *
 * Upstream ties enrage to dropping below 240hp (and spawns healers with it). Here it is
 * driven by progress instead, so it lands on the final three questions regardless.
 */
export const ENRAGE_WHEN_REMAINING = 3;

/** Same-origin, because the game is served from the trivia app's own static dir. */
export const API = {
  start: "/api/inferno/start",
  answer: "/api/inferno/answer",
  end: "/api/inferno/end",
};

export type Letter = "A" | "B" | "C" | "D";
export const LETTERS: Letter[] = ["A", "B", "C", "D"];

export interface Question {
  id: number;
  question: string;
  a: string;
  b: string;
  c: string;
  d: string;
}
